import cn from "classnames";

const Wave = ({
  type = "up-first",
  classNames,
  fill = "white",
  background,
}) => {
  const className = cn("wave", classNames);
  switch (type) {
    case "flex-reverse":
      return (
        <>
          <svg
            className={`${classNames}--d`}
            viewBox="0 0 1440 100"
            xmlns="http://www.w3.org/2000/svg"
            style={{ background: background }}
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1440 74C1092 20.4999 839.59 41.212 493.5 67.4999C304.088 81.8872 163 61 0 40.9084V-1.52588e-05H1440V74Z"
              fill="#00BCF1"
            />
          </svg>
          <svg
            className={`${classNames}--m`}
            viewBox="0 0 375 56"
            xmlns="http://www.w3.org/2000/svg"
            style={{ background: background }}
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M375 42C284.375 11.6351 218.643 23.3906 128.516 38.3108C79.1895 46.4765 42.4479 34.6216 0 23.2183V0H375V42Z"
              fill={fill}
            />
          </svg>
        </>
      );
    case "flex-up":
      return (
        <>
          <svg
            className={`${classNames}--d`}
            viewBox="0 0 1440 100"
            xmlns="http://www.w3.org/2000/svg"
            style={{ background: background }}
          >
            <path
              fillRule="evenodd"
              d="M1.25585e-05 0C26.6751 8.52381 55.6077 17.8858 87.1689 26.2375C511.179 138.439 805.12 18.169 994.532 3.78182C1183.94 -10.6054 1315.88 17.829 1440 59.0916V100H1.25585e-05V0Z"
              fill={fill}
            />
          </svg>
          <svg
            className={`${classNames}--m`}
            viewBox="0 0 375 56"
            xmlns="http://www.w3.org/2000/svg"
            style={{ background: background }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.00100708 0V56H375L375 52.0933C359.196 32.3818 324.944 24.6905 272.246 29.0191C264.868 29.6252 257.869 30.3502 251.195 31.1496L248.354 31.4966C247.414 31.6137 246.48 31.7322 245.552 31.852L242.788 32.2148C242.33 32.2759 241.874 32.3372 241.419 32.3988L238.71 32.7715L236.036 33.1498L233.396 33.5329L230.79 33.92C230.358 33.9848 229.928 34.0497 229.499 34.1148L225.674 34.703L223.787 34.9987L218.226 35.8881L214.597 36.4797L202.339 38.4999L198.95 39.0519L195.605 39.5877L192.581 40.0617L190.583 40.368L188.598 40.6658L186.626 40.9546L184.665 41.2337L182.716 41.5025L180.778 41.7605L178.849 42.007L176.929 42.2415L175.018 42.4633C174.382 42.535 173.748 42.6046 173.114 42.6718L171.217 42.8665C147.543 45.2108 125.292 44.1663 97.9797 34.4625C92.8613 32.644 87.8737 30.6881 82.978 28.6636L80.7248 27.7247C79.9759 27.4102 79.2289 27.0944 78.4839 26.7775L76.2543 25.8236L74.0353 24.8644L71.826 23.9016L67.433 21.9707L59.8099 18.6066L56.5607 17.1838L54.3984 16.2454L52.2381 15.3168L50.0791 14.3995L48.9998 13.9455L46.8411 13.048L45.7614 12.6048L43.601 11.7305C29.9126 6.24644 16.0947 1.80549 1.18073 0.126761L0.00100708 0Z"
              fill={fill}
            />
          </svg>
        </>
      );
    case "flex-bottom":
      return (
        <>
          <svg
            className={`${classNames}--d`}
            viewBox="0 0 1024 40"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M1024 0C1005.03 3.40952 984.457 7.15431 962.013 10.495C660.495 55.3756 451.47 7.26761 316.777 1.51273C182.084 -4.24216 88.2622 7.1316 0 23.6367V40H1024V0Z"
              fill={fill}
            />
          </svg>
          <svg
            className={`${classNames}--m`}
            viewBox="0 0 375 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.00100708 0V56H375L375 52.0933C359.196 32.3818 324.944 24.6905 272.246 29.0191C264.868 29.6252 257.869 30.3502 251.195 31.1496L248.354 31.4966C247.414 31.6137 246.48 31.7322 245.552 31.852L242.788 32.2148C242.33 32.2759 241.874 32.3372 241.419 32.3988L238.71 32.7715L236.036 33.1498L233.396 33.5329L230.79 33.92C230.358 33.9848 229.928 34.0497 229.499 34.1148L225.674 34.703L223.787 34.9987L218.226 35.8881L214.597 36.4797L202.339 38.4999L198.95 39.0519L195.605 39.5877L192.581 40.0617L190.583 40.368L188.598 40.6658L186.626 40.9546L184.665 41.2337L182.716 41.5025L180.778 41.7605L178.849 42.007L176.929 42.2415L175.018 42.4633C174.382 42.535 173.748 42.6046 173.114 42.6718L171.217 42.8665C147.543 45.2108 125.292 44.1663 97.9797 34.4625C92.8613 32.644 87.8737 30.6881 82.978 28.6636L80.7248 27.7247C79.9759 27.4102 79.2289 27.0944 78.4839 26.7775L76.2543 25.8236L74.0353 24.8644L71.826 23.9016L67.433 21.9707L59.8099 18.6066L56.5607 17.1838L54.3984 16.2454L52.2381 15.3168L50.0791 14.3995L48.9998 13.9455L46.8411 13.048L45.7614 12.6048L43.601 11.7305C29.9126 6.24644 16.0947 1.80549 1.18073 0.126761L0.00100708 0Z"
              fill={fill}
            />
          </svg>
        </>
      );
    case "up-first":
      return (
        <>
          <svg
            className={`${classNames} wave-desktop`}
            style={{ background: background }}
            viewBox="0 0 1024 40"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M1024 0C1005.03 3.40952 984.457 7.15431 962.013 10.495C660.495 55.3756 451.47 7.26761 316.777 1.51273C182.084 -4.24216 88.2622 7.1316 0 23.6367V40H1024V0Z"
              fill={fill}
            />
          </svg>
          <svg
            className={`${classNames} wave-mobile`}
            viewBox="0 0 375 56"
            xmlns="http://www.w3.org/2000/svg"
            style={{ background: background }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M375 0V56H0.000976563L0.000976562 52.0933C15.8054 32.3818 50.0568 24.6905 102.755 29.0191C110.133 29.6252 117.132 30.3502 123.806 31.1496L126.647 31.4966C127.587 31.6137 128.521 31.7322 129.449 31.852L132.213 32.2148C132.671 32.2759 133.127 32.3372 133.582 32.3988L136.291 32.7715L138.965 33.1498L141.605 33.5329L144.211 33.92C144.643 33.9848 145.073 34.0497 145.502 34.1148L149.327 34.703L151.214 34.9987L156.775 35.8881L160.404 36.4797L172.662 38.4999L176.051 39.0519L179.396 39.5877L182.42 40.0617L184.418 40.368L186.403 40.6658L188.375 40.9546L190.336 41.2337L192.285 41.5025L194.223 41.7605L196.152 42.007L198.072 42.2415L199.983 42.4633C200.619 42.535 201.253 42.6046 201.887 42.6718L203.784 42.8665C227.458 45.2108 249.709 44.1663 277.021 34.4625C282.14 32.644 287.127 30.6881 292.023 28.6636L294.276 27.7247C295.025 27.4102 295.772 27.0944 296.517 26.7775L298.747 25.8236L300.966 24.8644L303.175 23.9016L307.568 21.9707L315.191 18.6066L318.44 17.1838L320.603 16.2454L322.763 15.3168L324.922 14.3995L326.001 13.9455L328.16 13.048L329.24 12.6048L331.4 11.7305C345.088 6.24644 358.906 1.80549 373.82 0.126761L375 0Z"
              fill="#F0F2F9"
            />
          </svg>
        </>
      );
    case "down-first":
      return (
        <>
          <svg
            className={`${classNames} wave-desktop`}
            viewBox="0 0 1440 100"
            xmlns="http://www.w3.org/2000/svg"
            style={{ background: background }}
          >
            <path
              fillRule="evenodd"
              d="M1.25585e-05 0C26.6751 8.52381 55.6077 17.8858 87.1689 26.2375C511.179 138.439 805.12 18.169 994.532 3.78182C1183.94 -10.6054 1315.88 17.829 1440 59.0916V100H1.25585e-05V0Z"
              fill={fill}
            />
          </svg>
          <svg
            className={`${classNames} wave-mobile`}
            viewBox="0 0 375 56"
            xmlns="http://www.w3.org/2000/svg"
            style={{ background: background }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.00100708 0V56H375L375 52.0933C359.196 32.3818 324.944 24.6905 272.246 29.0191C264.868 29.6252 257.869 30.3502 251.195 31.1496L248.354 31.4966C247.414 31.6137 246.48 31.7322 245.552 31.852L242.788 32.2148C242.33 32.2759 241.874 32.3372 241.419 32.3988L238.71 32.7715L236.036 33.1498L233.396 33.5329L230.79 33.92C230.358 33.9848 229.928 34.0497 229.499 34.1148L225.674 34.703L223.787 34.9987L218.226 35.8881L214.597 36.4797L202.339 38.4999L198.95 39.0519L195.605 39.5877L192.581 40.0617L190.583 40.368L188.598 40.6658L186.626 40.9546L184.665 41.2337L182.716 41.5025L180.778 41.7605L178.849 42.007L176.929 42.2415L175.018 42.4633C174.382 42.535 173.748 42.6046 173.114 42.6718L171.217 42.8665C147.543 45.2108 125.292 44.1663 97.9797 34.4625C92.8613 32.644 87.8737 30.6881 82.978 28.6636L80.7248 27.7247C79.9759 27.4102 79.2289 27.0944 78.4839 26.7775L76.2543 25.8236L74.0353 24.8644L71.826 23.9016L67.433 21.9707L59.8099 18.6066L56.5607 17.1838L54.3984 16.2454L52.2381 15.3168L50.0791 14.3995L48.9998 13.9455L46.8411 13.048L45.7614 12.6048L43.601 11.7305C29.9126 6.24644 16.0947 1.80549 1.18073 0.126761L0.00100708 0Z"
              fill={fill ?? "#00BCF1"}
            />
          </svg>
        </>
      );
  }
};

export default Wave;
